module.exports = (function(window, document, undefined) {

  var grid = document.querySelectorAll('.grid-item');
  var seeMore = document.querySelector('.see-more');
  var expanding = document.querySelector('.expanding');
  var test = grid.length;

  function init() {

    if (!grid) {
      return;
    }


    function isEven(value) {
      if (value % 2 == 0) {
        return true;
      } else {
        return false;
      }
    }

    if (seeMore) {
      seeMore.addEventListener('click', function() {

        if (isEven(test) == true) {
          jQuery(".grid-item:nth-child(n+5)").toggle();
        } else {
          jQuery(".grid-item:nth-child(n+5)").toggle();
          jQuery(".jeans").toggle();
        }
        if (!seeMore.classList.contains('less')) {
          seeMore.innerHTML = 'SEE LESS';
          seeMore.classList.add('less');
          expanding.classList.add('rotate');
        } else {
          seeMore.innerHTML = 'SEE MORE';
          seeMore.classList.remove('less');
          expanding.classList.remove('rotate');
        }
      });
    }
  }
  return {
    init: init
  };

})(window, document);
